import { DictionariesListPage } from 'features/dictionaries/components/DictionariesListPage'
import { DictionaryType } from 'features/dictionaries/types'

export const DictionariesVehiclePage = () => {
  return <DictionariesListPage type={DictionaryType.Vehicle} />
}
